export default "__VITE_ASSET__BGEuWKn3__"